module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Контрагент",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.fullscreen ? 12 : 25
    },
    on: {
      "remove": _vm.removeRef,
      "click": _vm.selectRef
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Папка",
      "value": _vm.path,
      "hint": _vm.getDisplayPathByPath(_vm.getDepoCurrentPath),
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    on: {
      "input": _vm.onChangeFolder,
      "change": _vm.onChangeFolder
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('span', {
          style: (_vm.styleItem(data.item))
        }, [_vm._v(_vm._s(data.item.value))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 100 + 52)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          _vm.select(_vm.getItemKey(item))
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
          _vm.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "tile": ""
      }
    }, [_c(_vm.createPreview(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('b', [_vm._v(_vm._s(item.docName))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.uid))])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.cxt.selectedCount() === 0
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("ОК")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addFile()
      }
    }
  }, [_vm._v("Депонировать")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() === 0 && !_vm.radio),
      expression: "cxt.selectedCount() === 0 && !radio"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.checkAll()
      }
    }
  }, [_vm._v("Выбрать все")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() > 0),
      expression: "cxt.selectedCount() > 0"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.clear()
      }
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4f11880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocSelector.vue
// module id = 882
// module chunks = 1